import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { CookieService } from 'ngx-cookie-service';
import { NgxStripeModule } from 'ngx-stripe';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './appModules/core.module';
import { BasicAuthHtppInterceptorServiceService } from './core/auth/basic-auth-htpp-interceptor-service.service';
import { TenentIdentifierInterceptor } from './core/auth/tenantIdentifier/tenent-identifier.interceptor';
import { ServerErrorInterceptor } from './core/errorHandler/server-error.interceptor';
import { CardDetailsPageModule } from './includes/popups/card-details/card-details.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    TranslateLoader,
    TranslateModule
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BackupApiInterceptor } from './core/httpConfig/backup-api.interceptor';
import { SideMenuComponent } from './layouts/side-menu/side-menu.component';
import { TabMenuComponent } from './layouts/tab-menu/tab-menu.component';
import { SharedModule } from './shared/shared.module';
import { TenantResolver } from './appServices/tenant/tenant.resolver';

// Factory function for TranslateHttpLoader
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

// Ensure tenant is loaded from Capacitor Preferences before app starts
export function tenantInitFactory(tenantResolver: TenantResolver) {
    return () => tenantResolver.ensureLoaded();
}
@NgModule({
    declarations: [AppComponent, SideMenuComponent, TabMenuComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: 'en',
        }),
        SharedModule,
        CoreModule,
        CardDetailsPageModule,
        ReactiveFormsModule,
        FormsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            // enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }),
        NgxStripeModule.forRoot()], providers: [
            { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: BasicAuthHtppInterceptorServiceService,
                multi: true,
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: ServerErrorInterceptor,
                multi: true,
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: TenentIdentifierInterceptor,
                multi: true,
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: BackupApiInterceptor,
                multi: true,
            },
            {
                provide: APP_INITIALIZER,
                useFactory: tenantInitFactory,
                deps: [TenantResolver],
                multi: true,
            },
            CookieService,
            provideHttpClient(withInterceptorsFromDi()),
        ]
})
export class AppModule { }
